import { QuotePricingLineItemFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ProductRow from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/ItemRowTimeAndMaterial/ProductRow'
import RoleRow from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/ItemRowTimeAndMaterial/RoleRow'

interface ItemRowTimeAndMaterialProps {
  item: QuotePricingLineItemFragment
  currency: string
  isDraftStatus: boolean
  isJobCatalogTreeEnabled: boolean
  onUpdate: (updates: Partial<QuotePricingLineItemFragment>) => void
  onDelete: () => void
}

const ItemRow = ({
  item,
  currency,
  isDraftStatus,
  isJobCatalogTreeEnabled,
  onUpdate,
  onDelete,
}: ItemRowTimeAndMaterialProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  if (item.type === 'role') {
    return (
      <RoleRow
        item={item}
        currency={currency}
        isDraftStatus={isDraftStatus}
        isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
        locale={locale}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    )
  }

  return (
    <ProductRow
      item={item}
      currency={currency}
      isDraftStatus={isDraftStatus}
      locale={locale}
      onUpdate={onUpdate}
      onDelete={onDelete}
    />
  )
}

export default ItemRow
